import type React from 'react'

import { ChevronRightIcon } from '@heroicons/react/24/outline'
import { Button, type ButtonProps } from '@nextui-org/react'
import { Link, type LinkProps } from 'react-router-dom'

export type NavMenuItemProps =
  | ({
      asLink: true
      hasSubMenu?: boolean
      title: string
    } & ButtonProps &
      LinkProps &
      React.RefAttributes<HTMLAnchorElement>)
  | ({
      asLink?: false
      hasSubMenu?: boolean
      title: string
    } & ButtonProps)

export function NavMenuItem(props: Readonly<NavMenuItemProps>) {
  const { asLink, hasSubMenu = false, title, ...rest } = props

  return (
    <Button
      as={asLink ? Link : 'button'}
      className="flex justify-between px-0 font-medium uppercase"
      fullWidth
      size="lg"
      variant="light"
      {...rest}
    >
      {title} {hasSubMenu && <ChevronRightIcon className="h-6 w-6" />}
    </Button>
  )
}

export default NavMenuItem
